<template>
    <app-layout title="Profile">
        <form @submit.prevent="submit">
            <page-header>
                <template #title>Profile - {{ customer.name }}</template>

                <template #actions>
                    <div class="flex flex-col sm:flex-row justify-between gap-x-4 gap-y-2">
                        <jet-button type="button" class="leading-none inline-flex items-center" :href="editUrl">
                            Edit
                        </jet-button>
                    </div>
                </template>
            </page-header>

            <div class="px-8 xl:flex">
                <div class="block xl:flex flex-row gap-x-6 xl:w-2/3 xl:pr-8">
                    <!-- Column 1 -->
                    <div class="xl:w-1/2 flex flex-col gap-y-4">
                        <div>
                            <jet-label value="Address" class="whitespace-nowrap"/>
                            <div>{{ customer.address_1 }}</div>
                            <div>{{ customer.address_2 }}</div>
                            <div>{{ customer.city }} {{ customer.province }}, {{ customer.postal_code }}</div>
                        </div>
                        <div v-if="customer.po_num">
                            <jet-label value="PO #" class="whitespace-nowrap"/>
                            <div>{{ customer.po_num }}</div>
                        </div>
                        <div v-if="customer.phone">
                            <jet-label value="Phone" class="whitespace-nowrap"/>
                            <div>{{ customer.phone }}</div>
                        </div>
                        <div v-if="customer.cell">
                            <jet-label value="Cell" class="whitespace-nowrap"/>
                            <div>{{ customer.cell }}</div>
                        </div>
                        <div v-if="customer.fax">
                            <jet-label value="Fax" class="whitespace-nowrap"/>
                            <div>{{ customer.fax }}</div>
                        </div>
                        <div v-if="customer.email">
                            <jet-label value="Email" class="whitespace-nowrap"/>
                            <div>{{ customer.email.split(',').join(', ') }}</div>
                        </div>
                        <div v-if="customer.contact_name">
                            <jet-label value="Contact" class="whitespace-nowrap"/>
                            <div>{{ customer.contact_name }}</div>
                        </div>
                    </div>
                    <!-- Column 2 -->
                    <div class="xl:w-1/2 flex flex-col gap-y-4">
                        <!-- <div v-if="customer.type === 'School' || customer.credit_balance > 0">
                            <jet-label value="Prepaid & Fundraising Balance" class="whitespace-nowrap"/>
                            <div>${{ customer.credit_balance ?? 0 }}</div>
                            <div v-if="customer.auto_apply_credit" class="text-xs">Auto-apply</div>
                        </div> -->
                        <div v-if="customer.payment_terms_def">
                            <jet-label value="Payment Terms" class="whitespace-nowrap"/>
                            <div>{{ customer.payment_terms_def }}</div>
                        </div>
                        <div v-if="customer.payment_method_def">
                            <jet-label value="Payment Method" class="whitespace-nowrap"/>
                            <div>{{ customer.payment_method_def }}</div>
                        </div>
                        <div v-if="deliveryScheduleLines.length">
                            <jet-label value="Delivery Schedule" class="whitespace-nowrap"/>
                            <div v-for="(line, index) in deliveryScheduleLines" :key="index">{{ line }}</div>
                        </div>
                        <div v-if="customer.order_notes">
                            <jet-label value="Order Notes / Shipping Instructions" class="whitespace-nowrap"/>
                            <div>{{ customer.order_notes }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetLabel from '@/Jetstream/Label';
import JetButton from '@/Jetstream/Button';

export default {
    components: {
        AppLayout,
        PageHeader,
        JetLabel,
        JetButton,
    },

    props: [
        'customer', 
    ],

    computed: {
        editUrl() {
            return route('activecustomer.profile.edit');
        },

        deliveryScheduleLines() {
            // Prefer server-formatted lines (Mon–Fri 07:00 AM – 10:00 AM).
            if (Array.isArray(this.customer?.formatted_delivery_schedule_lines)) {
                return this.customer.formatted_delivery_schedule_lines.filter(Boolean);
            }

            const schedules = this.customer?.delivery_schedules || [];
            return schedules
                .map((schedule) => schedule.formatted_line || '')
                .filter(Boolean);
        },
    },
}
</script>

<style scoped>

</style>
